import { State } from './types'
import create from 'zustand/vanilla'
import { persist } from 'zustand/middleware'
import isBrowser from '../internal/utils/isBrowser'
import AsyncStorage from '@react-native-async-storage/async-storage'

const getPlatformStorage = () => {
  // wait until the code is compiled to access 'window' when using SSR
  if (!!isBrowser()) {
    return window?.navigator?.product === 'ReactNative'
      ? () => AsyncStorage
      : () => localStorage
  }
}

const options = {
  name: '@be/api',
  getStorage: getPlatformStorage()
}

export default create<State>(
  persist(
    (set) => ({
      networkId: undefined,
      networkSlug: undefined,
      token: '',
      refreshToken: '',
      target: undefined,
      isRefreshingToken: false,
      setTarget: (target: 'staging' | 'production') => set({ target }),
      setNetworkId: (networkId) => set({ networkId }),
      setNetworkSlug: (networkSlug) => set({ networkSlug }),
      setTokens: (tokens) => set({ ...tokens }),
      flush: () =>
        set({
          token: undefined,
          refreshToken: undefined
        })
    }),
    options
  )
)
